<template>
  <div>
   <div class="container my-5">
            <div class="row" v-if="categoryContentLoaded">
                <div class="col-md-4 col-sm-6 mb-3" v-for="(category, i) in productCategories"  :key="i">
                    
                        <!-- <router-link :to="'/category/' + category.dash + '/' + category.mask"> -->
                           <!-- <router-link :to="'/contact' "> -->
                        <!-- <div class="product-category-container" :style="{backgroundImage: 'url('+category.image+')'}"> -->
                           <div class="product-category-container" >
                           <a :href="category.image" class="fancybox" data-fancybox="images">
                             <img :src="category.image" class="img-fluid" alt="">
                           </a>
                            <div class="category-detail text-center">
                                <div>
                                    {{ category.name }}
                                </div>
                            </div>   
                                  
                        </div>
                        <!-- </router-link> -->
                    
                </div>

                
            </div>

            <div class="row" v-if="!categoryContentLoaded">
                <div class="col-md-4 col-sm-6 mb-3" v-for="(item, i) in fakeContentItems" :key="i">
                    <fake-content></fake-content>
                </div>
            </div>
        </div>

   
     <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
// import TopHeroBanner from "@/components/TopHeroBanner1.vue";
import axios from "axios";
import CoreValues from "../components/Core.vue";
import FakeContent from "../components/CategoryFakeContent.vue";
export default {
  components: { core: CoreValues, fakeContent: FakeContent },
  name: "promotions",
  data() {
    return {
      title: "Promotion",
        productCategories: [],
      fakeContentItems: 3,
      categoryContentLoaded: false
    };
  },
  methods:{
       fetchProductCategories() {
      axios
        .get(APIURL + "promotion")
        .then(response => {
          this.productCategories = response.data.data;
          this.categoryContentLoaded = true;
           this.$nextTick(function() {
               $(".fancybox").fancybox();
           });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  metaInfo() {
    return {
      title: "Promotion"
    };
  },
   created() {
    this.fetchProductCategories();
  }
};
</script>
